export default "__VITE_ASSET__uv3P1Vw4__"